module.exports = __webpack_public_path__ + "img/GEM.c0103638.svg";